module.exports = __webpack_public_path__ + "static/media/sence3.bfade696.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/sence3.png
// module id = 537
// module chunks = 0